import {FDSPhase} from '@web/core/constants'

import {FDSAction, OrderProcessPhase, ProcessingStep} from '../constants'
import {FDSState, OrderProcessorState} from '../slices/interfaces'

export function getInitialFdsState(): FDSState {
    return {
        phase: FDSPhase.IDLE,
        /** fds url */
        url: '',
        /** fds action type */
        actionType: FDSAction.POPUP,
        /** fds 인증 정보 */
        authentication: null,
    }
}

export function getInitialState(): OrderProcessorState {
    return {
        phase: OrderProcessPhase.IDLE,
        currentProcessStep: ProcessingStep.IDLE,
        shouldNextStep: false,
        finishStatus: null,
        orderSheetId: '',
        orderProcessNo: '',
        orderNo: '',
        channel: null,
        channelGroup: null,
        applyChannel: null,
        fds: getInitialFdsState(),
        requestStartOrderCount: 0,
        completed: false,
        processSteps: [],
        orderRequest: null,
        prepare: {
            orderProcessId: '',
            orderSessionIoAccessUrl: null,
            orderSessionIoChannel: null,
            applySessionIoAccessUrl: null,
            applySessionIoChannel: null,
        },
        applyOrderRequest: {},
        orderProcessResult: null,
        verificationKey: '',
        deviceLockType: 'INSECURE',
        isAutoPay: false,
    }
}
